import Loader from '@/authenticated/components/layout/Loader'
import { useAppDispatch, useAppSelector, useUrlSearchParam } from '@/hooks'
import { Redirect } from 'react-router-dom'
import AutogridConfirmation from '../confirmation'
import MultiProgramAutogridConfirmation from '../confirmation/multi-program-confirmation'
import { getCurrentUser } from '@/actions/user'
import { useEffect, useState } from 'react'
import { useProgramSpecificConfigFromUrlParam } from '@/app/hooks/useProgramSpecificConfigFromUrlParam'

export default function PartnerLogin() {
  const isExistingUser = useUrlSearchParam('existingUser') === 'true'
  const programIdParam = useUrlSearchParam('program_id')
  const [loadingUser, setLoadingUser] = useState(true)
  const dispatch = useAppDispatch()
  const { useMultiProgramFlow, isLoading: isLoadingProgramConfig } =
    useProgramSpecificConfigFromUrlParam()
  const authSuccess = useAppSelector(
    (state) => state.auth.access?.token && !state.auth.authLoading,
  )
  const authFailed = useAppSelector(
    (state) => Object.keys(state.auth.errors ?? {}).length > 0,
  )

  const updateUser = async () => {
    if (authSuccess) {
      await dispatch(getCurrentUser())
    }
    setLoadingUser(false)
  }

  useEffect(() => {
    // Front-load getting the user so we can show user related data
    // in the confirmation page
    updateUser()
  }, [authSuccess])

  if (isExistingUser && !useMultiProgramFlow) {
    return <AutogridConfirmation existingUser />
  } else if (isExistingUser && useMultiProgramFlow) {
    return <MultiProgramAutogridConfirmation existingUser />
  }

  const shouldRedirect = authSuccess && !loadingUser
  const waitForProgramConfig = Boolean(programIdParam) && isLoadingProgramConfig
  const confirmationPath = useMultiProgramFlow
    ? '/mp/autogrid/confirmation'
    : '/autogrid/confirmation'
  const redirectTo =
    programIdParam !== undefined && programIdParam !== null
      ? `${confirmationPath}?program_id=${programIdParam}`
      : confirmationPath

  return shouldRedirect && !waitForProgramConfig ? (
    <Redirect to={redirectTo} />
  ) : (
    <div className="flex justify-center w-full h-full mt-10">
      {authFailed ? (
        <div>
          <h1>Authentication failed</h1>
          <p>There was an error authenticating your account</p>
        </div>
      ) : (
        <Loader />
      )}
    </div>
  )
}
